const u = ({
  phone: r,
  dialCode: s,
  prefix: e = "+",
  charAfterDialCode: i = " "
}) => {
  if (!r || !s)
    return r;
  let t = r;
  return t.startsWith(e) && (t = t.replace(e, "")), t.startsWith(s) ? (t = t.replace(s, ""), t.startsWith(i) && (t = t.replace(i, "")), t) : r;
};
export {
  u as removeDialCode
};
